// import React from "react";
// import { motion } from "framer-motion";
// import { ChevronDown } from "lucide-react";

// const sections = [
//   {
//     title: "Skilled Talent Pool",
//     text: `We provide access to a diverse pool of highly skilled IT professionals. Our staff augmentation services allow you to quickly onboard experts in web development, QA, design, and other tech roles to meet your project needs efficiently.`,
//     img: "/staff1.jpg",
//   },
//   {
//     title: "Flexible Engagement",
//     text: `Scale your team up or down based on project requirements. Whether you need short-term support or long-term collaboration, our flexible engagement models ensure your business always has the right resources at the right time.`,
//     img: "/staff2.jpg",
//     reverse: true,
//   },
//   {
//     title: "Cost-Effective Solutions",
//     text: `Reduce hiring costs and administrative overhead by leveraging our staff augmentation services. You get experienced professionals without the burden of full-time employment, enabling efficient resource allocation and budget management.`,
//     img: "/staff3.jpg",
//   },
//   {
//     title: "Seamless Integration",
//     text: `Our experts integrate smoothly into your existing teams and processes, ensuring minimal disruption and maximum productivity. We provide continuous support and collaboration to ensure project success while maintaining your company culture.`,
//     img: "/staff4.jpg",
//     reverse: true,
//   },
// ];


// const ScrollSection = ({ children }) => (
//   <motion.div
//     initial={{ opacity: 0, y: 60 }}
//     whileInView={{ opacity: 1, y: 0 }}
//     transition={{ duration: 0.7, ease: "easeOut" }}
//     viewport={{ once: false, amount: 0.3 }}
//   >
//     {children}
//   </motion.div>
// );

// export default function WebDevelopmentTailwind() {
//   const handleScroll = () => {
//     document.getElementById("web-sections").scrollIntoView({ behavior: "smooth" });
//   };

//   return (
//   <div className="font-poppins text-gray-100 bg-black overflow-x-hidden scroll-smooth relative">

//     {/* ✨ Premium Gold Gradient Background */}
//     <div className="absolute inset-0 -z-10 bg-gradient-to-b from-black via-[#0A0A0A] to-[#1A1A1A]">
//       <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,_rgba(255,215,0,0.15),_transparent_70%)]"></div>
//       <div className="absolute inset-0 bg-[radial-gradient(circle_at_bottom_left,_rgba(212,175,55,0.18),_transparent_75%)]"></div>
//     </div>

//     {/* Hero Section */}
//     <ScrollSection>
//       <section className="relative h-screen flex flex-col items-center justify-center text-center overflow-hidden">
//         <motion.h1
//           initial={{ opacity: 0, y: 30 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.8 }}
//           className="text-[64px] font-extrabold uppercase tracking-wider mb-5 
//                      bg-gradient-to-r from-[#FFD700] to-[#B8860B] text-transparent bg-clip-text drop-shadow-xl"
//         >
//           Staff Augmentation
//         </motion.h1>

//         <motion.p
//           initial={{ opacity: 0, y: 30 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 1 }}
//           className="text-[20px] max-w-2xl text-gray-300 leading-relaxed"
//         >
//           Why are we the best Web Development Company in Indore?
//         </motion.p>

//         <motion.div
//           className="absolute bottom-20 cursor-pointer animate-bounce text-[#FFD700]"
//           onClick={handleScroll}
//           whileHover={{ scale: 1.2 }}
//         >
//           <ChevronDown size={42} />
//         </motion.div>
//       </section>
//     </ScrollSection>

//     {/* Sections */}
//     <div id="web-sections" className="max-w-6xl mx-auto py-24 px-6 md:px-10 space-y-24 relative z-10">
//       {sections.map(({ title, text, img, reverse }, idx) => (
//         <ScrollSection key={idx}>
//           <div className={`flex flex-col md:flex-row items-center gap-12 ${reverse ? "md:flex-row-reverse" : ""}`}>

//             {/* Text */}
//             <motion.div
//               className="flex-1 bg-gradient-to-br from-[#1A1A1A]/70 to-[#000]/70 
//                          backdrop-blur-[14px] p-10 md:p-12 rounded-[20px]
//                          border border-[#FFD700]/30 shadow-[0_10px_25px_rgba(255,215,0,0.12)]
//                          hover:shadow-[0_14px_30px_rgba(255,215,0,0.18)]
//                          transition-all duration-300"
//               whileHover={{ y: -5 }}
//             >
//               <h2 className="text-[38px] md:text-[38px] font-bold mb-4 
//                              bg-gradient-to-r from-[#FFD700] to-[#DAA520] text-transparent bg-clip-text
//                              relative after:block after:w-20 after:h-[3px] after:bg-[#FFD700] after:rounded mt-2"
//               >
//                 {title}
//               </h2>
//               <p className="text-[17px] md:text-[17px] leading-relaxed text-gray-300">{text}</p>
//             </motion.div>

//             {/* Image */}
//             <motion.div
//               className="flex-1 text-center"
//               whileHover={{ scale: 1.05 }}
//               transition={{ duration: 0.4 }}
//             >
//               <img
//                 src={img}
//                 alt={title}
//                 className="w-full max-w-md md:max-w-lg rounded-[20px] 
//                            border border-[#FFD700]/25 shadow-[0_12px_30px_rgba(255,215,0,0.18)]"
//               />
//             </motion.div>

//           </div>
//         </ScrollSection>
//       ))}
//     </div>

//     <style>{`
//       @keyframes bounce {
//         0%,100% { transform: translateY(0); }
//         50% { transform: translateY(10px); }
//       }
//       .animate-bounce {
//         animation: bounce 1.8s infinite;
//       }
//     `}</style>
//   </div>
// );

// }




import React from "react";
import { motion } from "framer-motion";
import { ChevronDown } from "lucide-react";

const sections = [
  {
    title: "Skilled Talent Pool",
    text: `We provide access to a diverse pool of highly skilled IT professionals. Our staff augmentation services allow you to quickly onboard experts in web development, QA, design, and other tech roles to meet your project needs efficiently.`,
    img: "/staff1.jpg",
  },
  {
    title: "Flexible Engagement",
    text: `Scale your team up or down based on project requirements. Whether you need short-term support or long-term collaboration, our flexible engagement models ensure your business always has the right resources at the right time.`,
    img: "/staff2.jpg",
    reverse: true,
  },
  {
    title: "Cost-Effective Solutions",
    text: `Reduce hiring costs and administrative overhead by leveraging our staff augmentation services. You get experienced professionals without the burden of full-time employment, enabling efficient resource allocation and budget management.`,
    img: "/staff3.jpg",
  },
  {
    title: "Seamless Integration",
    text: `Our experts integrate smoothly into your existing teams and processes, ensuring minimal disruption and maximum productivity. We provide continuous support and collaboration to ensure project success while maintaining your company culture.`,
    img: "/staff4.jpg",
    reverse: true,
  },
];

const ScrollSection = ({ children }) => (
  <motion.div
    initial={{ opacity: 0, y: 60 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.7, ease: "easeOut" }}
    viewport={{ once: false, amount: 0.3 }}
  >
    {children}
  </motion.div>
);

export default function StaffAugmentationPage() {
  const handleScroll = () => {
    document.getElementById("web-sections").scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="font-poppins text-gray-100 bg-black overflow-x-hidden scroll-smooth relative">

      {/* Premium Gold Background */}
      <div className="absolute inset-0 -z-10 bg-gradient-to-b from-black via-[#0A0A0A] to-[#1A1A1A]">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,_rgba(255,215,0,0.15),_transparent_70%)]"></div>
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_bottom_left,_rgba(212,175,55,0.18),_transparent_75%)]"></div>
      </div>

      {/* Hero Section */}
      <ScrollSection>
        <section className="relative min-h-[80vh] sm:h-screen flex flex-col items-center justify-center text-center px-4 overflow-hidden">
          
          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-[34px] sm:text-[48px] md:text-[64px] font-extrabold uppercase tracking-wider mb-4
            bg-gradient-to-r from-[#FFD700] to-[#B8860B] text-transparent bg-clip-text drop-shadow-xl"
          >
            Staff Augmentation
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
            className="text-[15px] sm:text-[18px] md:text-[20px] max-w-xl sm:max-w-2xl text-gray-300 leading-relaxed"
          >
            Why are we the best Web Development Company in Indore?
          </motion.p>

          <motion.div
            className="absolute bottom-10 sm:bottom-20 cursor-pointer animate-bounce text-[#FFD700]"
            onClick={handleScroll}
            whileHover={{ scale: 1.2 }}
          >
            <ChevronDown size={36} />
          </motion.div>
        </section>
      </ScrollSection>

      {/* Sections */}
      <div
        id="web-sections"
        className="max-w-7xl mx-auto py-16 sm:py-24 px-4 sm:px-6 md:px-10 space-y-20"
      >
        {sections.map(({ title, text, img, reverse }, idx) => (
          <ScrollSection key={idx}>
            <div
              className={`flex flex-col md:flex-row items-center gap-10 sm:gap-12 ${
                reverse ? "md:flex-row-reverse" : ""
              }`}
            >
              {/* Text */}
              <motion.div
                className="flex-1 bg-gradient-to-br from-[#1A1A1A]/70 to-[#000]/70 
                backdrop-blur-[14px] p-6 sm:p-8 md:p-10 rounded-[20px]
                border border-[#FFD700]/30 shadow-[0_10px_25px_rgba(255,215,0,0.12)]
                hover:shadow-[0_14px_30px_rgba(255,215,0,0.18)]
                transition-all duration-300"
                whileHover={{ y: -5 }}
              >
                <h2 className="text-[26px] sm:text-[32px] md:text-[38px] font-bold mb-4
                bg-gradient-to-r from-[#FFD700] to-[#DAA520] text-transparent bg-clip-text">
                  {title}
                </h2>

                <div className="w-16 h-[3px] bg-[#FFD700] rounded mb-4"></div>

                <p className="text-[15px] sm:text-[17px] leading-relaxed text-gray-300">
                  {text}
                </p>
              </motion.div>

              {/* Image */}
              <motion.div
                className="flex-1 text-center"
                whileHover={{ scale: 1.05 }}
                transition={{ duration: 0.4 }}
              >
                <img
                  src={img}
                  alt={title}
                  className="w-full max-w-sm sm:max-w-md md:max-w-lg rounded-[20px]
                  border border-[#FFD700]/25 shadow-[0_12px_30px_rgba(255,215,0,0.18)]"
                />
              </motion.div>
            </div>
          </ScrollSection>
        ))}
      </div>

      {/* Bounce Animation */}
      <style>{`
        @keyframes bounce {
          0%,100% { transform: translateY(0); }
          50% { transform: translateY(10px); }
        }
        .animate-bounce {
          animation: bounce 1.8s infinite;
        }
      `}</style>
    </div>
  );
}
